import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class VisitService {
  constructor(private http: HttpClient) {}

  requestVisit(newVisit: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/api/visit/create/offline`,
      newVisit
    );
  }
}
